import { ApiService } from 'app/services/api_service';
import { EthplorerService } from 'app/services/ethplorer_service';
import { CoinGeckoService } from 'app/services/coingecko_service';

export type Services = {
  apiService: ApiService;
  ethplorerService: EthplorerService;
  coinGeckoService: CoinGeckoService;
  localStorage?: Storage;
};

export const services: Services = {
  apiService: new ApiService(),
  ethplorerService: new EthplorerService(),
  coinGeckoService: new CoinGeckoService(),
};
